let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1qLpu"), load("8qEcu"), load("joJy8"), load("aHE9G"), load("c6MKV"), load("cGAab")]).then(() => parcelRequire('c2Ip8'));